<template>
<div data-component="DropdownSelect.vue" :data-variant="variant" class="dropdown" :class="{ 'is-focused': Focused , 'is-arrowless': Arrowless }" @keydown="OnKey" @click.prevent.stop="OnClick">
	<slot v-if="$slots.button" name="button"/>
	<button v-else class="dropdown-button | outline-none" :class="{ '!cursor-default': (Disabled || Items.length < 1) && !IsDisplayAlways }" :disabled="Disabled">
		<slot v-if="$slots.label" name="label"/>
		<div v-else :class="{ 'text-neutral-600': !Labels[Value] && DimmedPlaceholder }">
			<OIcon v-if="Icons[Value]" v-bind="Icons[Value]" :size="1.25" class="relative mr-3 top-1"/>
			<span v-html="Labels[Value] ? Labels[Value] : Placeholder"/>
		</div>
	</button>
	<div ref="suggestionList" class="suggestions-list scroll-gray">
		<template v-for="(item, i) in Items">
			<a v-if="item.Value" :key="i" :data-test="item.DataTest || 'dropdown__option'" :class="[item.Class || '', (Value === item.Value && !item.IsAction) ? 'is-selected bg-neutral-50 font-bold' : '']" @click="OnSelect(item)">
				<OIcon v-if="item.Icon" v-bind="item.Icon" :size="1.25" class="relative mr-3 top-1"/>
				<span v-html="item.Label"/>
			</a>
		</template>
	</div>
</div>
</template>

<script lang="ts">
import { PropType } from 'vue';

// @vuese
// Komponent odpowiedzialny za kontrolkę wyboru elementu z listy.
// @group Base Components | Forms
export default {
	name: 'DropdownSelect',
	props: {
		modelValue: { default: '' },
		Items: {
			default: () => [],
			type: Array as PropType<Array<{ Value: string, Label: string, DataTest?:string, Class?:string, Icon?:{ name:string, set?:string } }>>,
		}, // eslint-disable-line no-array-constructor
		Placeholder: {
			type: String,
			default: '',
		},
		Disabled: {
			type: Boolean,
			default: false,
		},
		Arrowless: {
			type: Boolean,
			default: false,
		},
		variant: {
			type: String,
			default: '',
		},
		DimmedPlaceholder: {
			type: Boolean,
			default: true,
		},
		IsDisplayAlways: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['update:modelValue', 'change'],
	data() {
		return {
			Value: '',
			Labels: {},
			Icons: {},
			Focused: false,
		};
	},
	watch: {
		modelValue(n) {
			this.Value = n;
		},
		Items(n) {
			this.Labels = {};
			this.Icons = {};
			for (const i of n) {
				this.Labels[i.Value] = i.Label;
				if (i.Icon) { this.Icons[i.Value] = i.Icon; }
			}
		},
	},
	created() {
		try {
			for (const i of this.Items || []) {
				this.Labels[i.Value] = i.Label;
				if (i.Icon) { this.Icons[i.Value] = i.Icon; }
			}
		} catch (err) {}
		this.Value = this.modelValue;
	},
	methods: {
		OnKey(e) {
			if (!['ArrowDown', 'ArrowUp', 'Enter', 'Escape'].includes(e.key)) { return; }
			if (['Enter', 'Escape'].includes(e.key)) {
				this.Focused = false;
			}

			if (['ArrowDown', 'ArrowUp'].includes(e.key)) {
				e.preventDefault();

				const currentItem = this.Items.findIndex((i) => i.Value === this.Value);
				if (currentItem === -1) { return; }
				let itemToSelect;
				if (e.key === 'ArrowDown') {
					itemToSelect = this.Items[currentItem + 1] ? this.Items[currentItem + 1] : this.Items[0];
				} else {
					itemToSelect = this.Items[currentItem - 1] ? this.Items[currentItem - 1] : this.Items[this.Items.length - 1];
				}

				if (itemToSelect) { this.OnSelect(itemToSelect, 'key'); }
			}
		},
		OnClick() {
			if ((this.Disabled || this.Items.length < 1) && !this.IsDisplayAlways) { return; }
			this.Focused = !this.Focused;
		},
		OnSelect(i, source = 'click') {
			this.Value = i.Value;
			// TODO: v to nie powinno trafić tutaj, tylko jako obsłużęnie eventu!!!!11
			if (this.Value === 'MyRfps' || this.Value === 'BuyerView') { this.Analytics.sendGAEvent('click_rfpList'); }
			if (this.Value === 'close') { this.Analytics.sendGAEvent('click_exitRfp'); }
			this.$emit('update:modelValue', this.Value);
			this.$emit('change', this.Value);
			if (source === 'key') {
				const suggestionList = this.$refs.suggestionList as HTMLElement;
				if (suggestionList) {
					window.setTimeout(() => {
						// TODO: Weź prawidłowy element, zamiast opierając się na klasie.
						const selectedItem = suggestionList.querySelector('.is-selected');
						if (selectedItem) { selectedItem.scrollIntoView({ block: 'nearest' }); }
					}, 20);
				}
			}
		},
	},
};
</script>

<style lang="scss">
.dropdown.is-arrowless {
	& > button::after {
		display: none;
	}

	.suggestions-list {
		top: 2rem;
	}

	&.is-focused .suggestions-list {
		width: fit-content;
	}
}
.dropdown[data-variant="with-shadow"] {
	@apply border-neutral-200;
	.suggestions-list {
		box-shadow: 0px 3px 12px 6px #0000000F, 0.75px 4.5px 6px 0px #00000014;
		padding: 4px 0;
		transition-property: opacity;
		a {
			display: flex;
			align-items: center;
			padding: 8px 12px;
		}
		a i {
			top: 0;
			color: var(--accent-400);
		}
		a.dropdown-separator {
			@apply border-t border-neutral-200;
			padding: 0;
			margin: 4px 0;
		}
	}
}
</style>
